import { useAppLoadingStore } from '@/stores/loading.store';

type LoadingActionPayload = {
    visibleFlag?: boolean;
};

/**
 * 提供 Razor 舊頁面使用的 loading bridge
 */
class LoadingStore {
    private readonly store = useAppLoadingStore();

    /**
     * 是否正在 loading
     */
    get isLoading(): boolean {
        return this.store.isLoading;
    }

    /**
     * 是否顯示 loading
     */
    get showLoading(): boolean {
        return this.store.showLoading;
    }

    /**
     * 開始 loading
     */
    start(payload: LoadingActionPayload = {}): void {
        this.store.start(payload);
    }

    /**
     * 結束 loading
     */
    end(payload: LoadingActionPayload = {}): void {
        this.store.end(payload);
    }

    /**
     * 重置 loading
     */
    reset(): void {
        this.store.reset();
    }
}

let loadingStoreBridge: LoadingStore | null = null;

const getLoadingStoreBridge = (): LoadingStore => {
    if (!loadingStoreBridge) {
        loadingStoreBridge = new LoadingStore();
    }

    return loadingStoreBridge;
};

/**
 * 安裝 loading store runtime
 */
export const installLoadingStoreRuntime = (): void => {
    window.LoadingStore = LoadingStore;

    if (!window.loadingStore) {
        window.loadingStore = getLoadingStoreBridge();
    }
};
